// import Numeral from 'numeral';
// import moment from 'moment-timezone';

export default class BootstrapField {
	static get Types() {
		return {
			checkbox: 'checkbox',
			currency: 'currency',
			date: 'date',
			email: 'email',
			number: 'number',
			percentage: 'percentage',
			select: 'select',
			text: 'text',
			time: 'time',
			textarea: 'textarea'
		};
	}

	constructor(data) {
		if (!data) {
			data = {};
		}

		if (data.value instanceof BootstrapField) {
			this.data = this.value;
		}

		// if (data.type == BootstrapField.Types.date && data.value) {
		// 		data.value = Format.utcToPickerDate(data.value);
		// }


		// if (data.type == BootstrapField.Types.date) {
		// 	if (data.value) {

		// 		const winnipeg = moment
		// 		    .utc(data.value)
		// 		    .tz('America/Winnipeg');

		// 		data.value = new Date(
		// 		    winnipeg.year(),
		// 		    winnipeg.month(),
		// 		    winnipeg.date(),
		// 		    winnipeg.hour(),
		// 		    winnipeg.minute(),
		// 		    winnipeg.second()
		// 		);


		// 		// data.value = new Date(data.value);
		// 	}
		// }


		Object.assign(this, {
			value: null,
			status: null,
			validator: data.validator || null,
			required: data.required || false,
			invalidMessage: data.invalidMessage || null,
			fnValue: data.fnValue || null,
			fnRawValue: data.fnRawValue || null,
			type: data.type || null,
			relatedField: data.relatedField || null, // if it is time picker, what is the related date picker.
			valueChanged: data.valueChanged,
			rawValue: null,
			dirty: false
		});

		if (data.value != undefined) {
			this.value = data.value;
		}

		if (!this.invalidMessage) {
			this.invalidMessage = 'Field required';

			if (this.validator) {
				this.invalidMessage = 'Invalid value';
			}
		}

	}

	validate() {
		this.resetStatus();

		if (this.valid) {
			this.status = null;
		} else {
			this.status = false;
		}

		return this.status;
	}

	get valid() {
		let isValid = true;

		if (this.required) {
			if (this.hasValue) {
				if (this.value instanceof Array && this.value.length == 0) {
					isValid = false;
				}
				if (typeof this.value == "string" && "" + this.value.trim() == "") {
					isValid = false;
				}
			} else {
				isValid = false;
			}
		}

		if (this.validator && this.hasValue) {
			if (!this.validator(this.value)) {
				isValid = false;
			}
		}

		return isValid;
	}

	resetStatus() {
		this.status = null;
	}
	setDirty() {
		this.dirty = true;
	}
	setClean() {
		this.dirty = false;
	}

	getValue() {
		if (this.fnValue) {
			return this.fnValue(this.value);
		} else {
			return this.value;
		}
	}
	getRawValue() {
		if (this.fnRawValue) {
			return this.fnRawValue(this.value);
		} else {
			if (this.type) {
				if (this.type == BootstrapField.Types.date) {
					if (this.value == null) {
						return null;
					} else {
						// return moment.utc(this .value).format();
						return this.value;
					}
				}
				return this.getValue();
			} else {
				return this.getValue();
			}
		}
	}


	/**
	 * @param {string} value
	 */
	set invalidMsg(value) {
		if (!value) {
			this.invalidMessage = 'Field required';

			if (this.validator) {
				this.invalidMessage = 'Invalid value';
			}
		} else {
			this.invalidMessage = value;
		}
	}

	get hasValue() {
		return ((typeof this.value) !== 'undefined') && (this.value != null);
	}
}